import {atom, useAtom} from "jotai";

const configAtom = atom(null);

export const useConfig = () => {
    return useAtom(configAtom);
    }